import { useState, useEffect } from 'react';

export const useLoginDomains = () => {
  const [domains, setDomains] = useState<string[]>(() => {
    try {
      const storedDomains = localStorage.getItem('domains');
      return storedDomains ? JSON.parse(storedDomains) : [];
    } catch (error) {
      console.warn('Failed to parse domains from local storage. It will be ignored.');
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('domains', JSON.stringify(domains));
    } catch (error) {
      console.error('Failed to save domains to local storage:', error);
    }
  }, [domains]);

  const addDomain = (domain: string) => {
    setDomains((prevDomains) => [...prevDomains, domain]);
  };

  const clearValue = (value: string) => {
    setDomains((prevDomains) => prevDomains.filter((domain) => domain !== value));
  };

  return { domains, addDomain, clearValue };
};
